import React from 'react';
import { Routes } from './../Core/Constants';
import { AppStore } from './../Core/AppStore'


export default class AddToCartModal extends React.Component {
	constructor(props) {
		super(props);
	}
	state = {
		product: null,
		coupon: null
	}

	componentDidMount = () => {

		AppStore.on('Cart.AddingProduct', (product) => {
			this.setState({
				product: product
			});
		});

		AppStore.on('Cart.CouponAdded', (coupon) => {
			this.setState({
				coupon: coupon
			});
		});
	}
	

	handleClose = (e) => {
		e.preventDefault();
		this.setState({ product: null, coupon: null });
	}

	render = () => {
		let product = this.state.product;
		let coupon = this.state.coupon;
		if (!product && !coupon) return null;
		var T = window.Texts.catalogue;
		return product ?
			<div className="add-2-cart-modal" style={{ display: 'block'}}>
				<div className="modal-cover">
					<div className="modal-content">
						<div className="header">
							<h5>{T.goodsAdd}:</h5>
							<a className="close" href="#" onClick={(e) => this.handleClose(e)}></a>
						</div>
						<div className="item-in-cart">
							<div className="thumb"><img src={product.picture} /></div>
							<a href={product.url}><u>{product.name}</u></a>
							<span><strong>{product.price}</strong> {T.withTax}</span>
						</div>
						<div className="button">
							<a className="close" href="#" onClick={(e) => this.handleClose(e)}><span>{T.contin}</span></a>
							<a className="btn iconed icon-continue" style={{ padding: '0px 10px'}} href={Routes.Cart}><span>{T.toCart}</span></a>
						</div>
					</div>
				</div>
			</div>
			:
			<div className="add-2-cart-modal" style={{ display: 'block' }}>
				<div className="modal-cover">
					<div className="modal-content">
						<div className="header">
							<h5>{T.couponAdd}</h5>
							<a className="close" href="#" onClick={(e) => this.handleClose(e)}></a>
						</div>
						<div className="item-in-cart">
							<div className="thumb"><img src="content/img/barcode48.png" /></div>
							<u>{coupon.code}</u>
							<span><strong>{coupon.discount}</strong> {T.withTax}</span>
						</div>
					</div>
				</div>
			</div>;
	}
}

//inicializace
var element = document.getElementById("app-cart-modal");
if (element) {
	ReactDOM.render(<AddToCartModal />, element);
}




